import axios from 'axios';
const STORE_URL = 'https://happyboxstore.com';
const ADDON_PRODUCT_TYPE = 'Gift';
const BUILDER_HANDLE = 'build-a-happy-box';
const GOC_HANDLE = 'gift-collection-test-1';
const RTS_HANDLE = 'ready-to-ship-products';
const actions = {
    async start(context){
      //get page handle
      let pathname = location.pathname;
      // get page occasions by pulling the metafields
      let metafields = await axios.get(`${pathname}?view=metafields`);
      if(metafields 
        && metafields.data 
        && metafields.data.metafields 
      ){
        context.commit('setOccasion', metafields.data.metafields.related_occasion);
        if(metafields.data.metafields.related_products && metafields.data.metafields.related_products.length > 0){
          let productsIds = metafields.data.metafields.related_products.map((x) =>{
            let split = x.split("/");
  
            return parseInt(split.pop());
          })
          context.commit('setAddonIds', productsIds);
        }
        context.commit('setGocImage', metafields.data.metafields.goc_image);
        context.commit('setWaysImages', metafields.data.metafields.ways_to_shop_images);
        context.commit('setHeaders', metafields.data.metafields.header);
        context.commit('setSlides',metafields.data.metafields.slider)
        //get Builder gifts
        getProducts();
        //Get RTS Gifts
        let relatedRts = [];
        if(metafields.data.metafields.related_rts && metafields.data.metafields.related_rts.length > 0){
          relatedRts = metafields.data.metafields.related_rts.map((x) =>{
            let split = x.split("/");
  
            return parseInt(split.pop());
          })
        }
        getCollectionProducts(RTS_HANDLE, relatedRts);
        //Get GOC Gifts
      }

      async function getCollectionProducts(pathname,filterIds){
        axios.get(`${STORE_URL}/collections/${pathname}/products.json?limit=250`)
        .then(response => response.data)
        .then((data) => {
          let products = []
          if(filterIds && filterIds.length > 0){
            products = data.products.filter((product) => {
              product.variants = product.variants.filter(x => parseFloat(x.price) > 0 && x.available == true);
              
              return filterIds.includes(product.id) && product.variants.length > 0;
            });
          }
          else{
            products = data.products.filter((product) => {
              let isOccasion = product.tags.some(tag => tag.includes(context.state.occasion));
              product.variants = product.variants.filter(x => parseFloat(x.price) > 0 && x.available == true);
              
              return product.variants.length > 0 && isOccasion;
            });
          }
          context.commit('setRtsProducts', products);
        })
      }

      async function getProducts() {
        axios.get(`${STORE_URL}/collections/${BUILDER_HANDLE}.json`)
        .then(response => response.data)
        .then((data) => {
          // Figure out how many pages of data we have to pull
          const numOfPages = Math.ceil(data.collection.products_count / 250);
          fetchProducts(numOfPages, []);
        })
        .catch((err) => {
          console.log('***Error Fetching NumOfProducts***');
        });
    
        function fetchProducts(pageNum, productList) {
          // Recursive function that gets the full list of products
          if (pageNum != 0) {
            axios.get(`${STORE_URL}/collections/${BUILDER_HANDLE}/products.json?limit=250&page=${pageNum}`)
              .then(response => response.data)
              .then((data) => {
                const updatedProductList = [...data.products, ...productList];
                fetchProducts(pageNum - 1, updatedProductList);
              })
              .catch((err) => {
                console.log('***Error Fetching Products***');
              });
          } else {
            sortFetchedProducts(productList);
          }
        }
      }
      function sortFetchedProducts(totalProductList) {
        axios.get('https://api.happyboxstore.com/api/bundle/getGiftProducts')
        .then(response => response.data)
        .then((data) => {
          totalProductList =  totalProductList.map((item, i) => Object.assign({}, item, data.find(x => x.id == item.id)));
  
          var addonProductList = totalProductList.filter((product) => {
            if (product.product_type == ADDON_PRODUCT_TYPE && ((context.state.addonIds.length > 0 && context.state.addonIds.includes(product.id)) || context.state.addonIds.length == 0) && (product.variants.some(x => x.inventory_quantity > 0) || product.variants.some(x => x.inventory_policy == "continue"))) {
              product.tags = product.tags.split(', ')
              product.variants = product.variants.filter(x => parseFloat(x.price) > 0).map((variant) =>{
                variant.inventory_quantity = variant.inventory_policy == "continue" ? 9999 : variant.inventory_quantity;
                variant.available = variant.inventory_quantity > 0;
                variant.sku = variant.sku ? variant.sku : "";
                variant.featured_image = product.images.find(x => x.id == variant.image_id)
                return variant
              })
      
              return product;
            }
          });
          context.commit('setAddonProducts', addonProductList);
        })
        .catch((err) => {
          console.log(err);
          console.log('***Error Fetching NumOfProducts***');
        });
      }
    },
};

export default actions;
